// src/auth/authContextObject.js — the AuthContext object on its own.
//
// ⭐ Split out of AuthContext.jsx (v203) so a component can read the session NULL-SAFELY (useCanBuyPlans) without
// importing AuthContext.jsx — which many suites mock with only `useAuth`, and whose `useAuth` throws outside the
// provider. The provider in AuthContext.jsx still owns the value.
import { createContext } from 'react';

export const AuthContext = createContext(null);
